import React, { useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Badge from '@mui/material/Badge';
import axios from 'axios';

const Calendar = (props:any) => {

  const [yyyymm , setYyyymm] = useState("")

  const [highlightedDays , setHighlightedDays] = useState("")
  
  const getDays = async () => {

    var result = await axios.get("http://localhost:9680/attendanceHistory", {
      params : {ymd: yyyymm},
      withCredentials: true,
    });
  
    const datas = result.data.datas.map((data: any) => {
      return data.require_date;
    });

    setHighlightedDays(datas)
    return datas;
  };

  useEffect(() => {
    getDays()
  }, [yyyymm]);

  useEffect(() => {
    const initialValue = dayjs(new Date());
    setYyyymm(dayjs(initialValue).format('YYYY-MM')) //2023-03 02 04
    getDays()
  }, []);
  

  const onChangeYyyymm = (date: any) =>{

    var change_yyyymm = dayjs(date.$d).format('YYYY-MM')

    if(yyyymm != change_yyyymm){
      console.log('다름')
      setYyyymm(change_yyyymm)
    }else{
      console.log('같음')
    }
  
  }

  const onChange = (date: any) =>{
    console.log('onChange :::::: ' , date)
  
    var click_date = dayjs(date.$d).format('YYYY-MM-DD')
    console.log('click date :::: ' , click_date)

    const isSelected = highlightedDays.includes(click_date)

    if(isSelected){
      props.setClick_date(click_date)
    }
  }
  

  function ServerDay(props: PickersDayProps<Dayjs> & { highlightedDays?: string[] }) {
    const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  
    
    var ymd  = dayjs(props.day).format('YYYY-MM-DD')

    const isSelected = highlightedDays.includes(ymd)

    return (
      <Badge
        key={props.day.toString()}
        overlap="circular"
        badgeContent={isSelected ? '😛' : undefined}
      >
        <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
      </Badge>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar showDaysOutsideCurrentMonth 
      // defaultValue={dayjs(new Date())}
      slots={{day: ServerDay}} slotProps={{day: {highlightedDays} as any,}} onChange={(e:any) => {onChangeYyyymm(e); onChange(e)}} onMonthChange={(e:any) => onChangeYyyymm(e)} />
    </LocalizationProvider>
  );
}
export default Calendar;